import PropTypes from "prop-types";
import styles from "./index.css";

const TextOverflowFade = ({ text }) => (
  <div className={styles.overflowFade}>
    <div>
      <p>{text}</p>
    </div>
  </div>
);

TextOverflowFade.propTypes = {
  text: PropTypes.string.isRequired
};

export default TextOverflowFade;
